import type { TrackProps, PageProps } from '../context';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TrackFunctionType = (...args: any[]) => TrackProps;
export type TrackFunctionMap = Readonly<{ [trackFunctionName: string]: TrackFunctionType }>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type PageFunctionType = (...args: any[]) => Omit<PageProps, 'action'>;
export type PageFunctionMap = Readonly<{ [pageFunctionName: string]: PageFunctionType }>;

export interface TelemetryContextProps<A, C>
  extends Readonly<{
    actions: A;
    context?: C;
    updateContext: (input: Partial<C> | ((prevContext: C) => C)) => void;
  }> {}

export interface UseTelemetryArgs<C, P extends PageFunctionMap>
  extends Readonly<{
    contextUpdate?: C;
    addToContext?: Partial<C>;
    page?: keyof P;
  }> {}

export interface TelemetryObjectArgs<A extends TrackFunctionMap, P extends PageFunctionMap>
  extends Readonly<{
    actions: A;
    pages?: P;
  }> {}

export enum FUNNEL {
  Converter = 'converter',
}
